<template>
  <div class="view pa24">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto">
      <el-form-item label="选择分类" prop="settingId">
        <el-select
          v-model="ruleForm.settingId"
          placeholder="请选择"
          style="width: 400px"
        >
          <el-option
            v-for="item in options"
            :key="item.settingId"
            :label="item.name"
            :value="item.settingId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="需求描述" prop="description">
        <el-input
          type="textarea"
          placeholder="请输入内容"
          v-model="ruleForm.description"
          maxlength="200"
          rows="4"
          style="width: 400px"
          show-word-limit
        >
        </el-input>
      </el-form-item>
      <el-form-item label="添加图片">
        <el-upload
          action="https://api.weishanglian.cn/file/uploadObjectOSS"
          list-type="picture-card"
          :on-progress="handProgress"
          :on-success="handleSuccess"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove"
          :file-list="ruleForm.fileList"
          :limit="6"
        >
          <i class="el-icon-plus"></i>
          <div slot="tip" class="el-upload__tip">
            上传图片的最佳尺寸：750像素*422像素，其他尺寸会影响页面效果，格式png，jpeg，jpg。大小不超过2M，最少上传1张最多可上传6张
          </div>
        </el-upload>
        <el-dialog
          :visible.sync="dialogVisible"
          :modal-append-to-body="false"
          :destroy-on-close="true"
        >
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </el-form-item>
      <el-form-item label="备注" prop="note">
        <el-input
          type="text"
          placeholder="请输入内容"
          maxlength="50"
          v-model="ruleForm.note"
          style="width: 400px"
          show-word-limit
        >
        </el-input>
      </el-form-item>
      <el-form-item label="所在位置" prop="address">
        <el-input
          id="suggestId"
          type="text"
          placeholder="请输入地址"
          v-model="ruleForm.address"
          maxlength="50"
          @change="theLocation"
          style="width: 400px"
          show-word-limit
        />
        <div
          id="baidumap"
          style="width: 400px; height: 400px; margin-top: 10px"
        ></div>
      </el-form-item>
      <el-form-item>
        <el-radio v-model="radio" label="1">我已阅读<a>用户协议</a></el-radio>
      </el-form-item>
    </el-form>
    <el-row align="right" style="width: 800px; text-align: right">
      <el-button type="primary" @click="saveForm('1')">保存到草稿</el-button>
      <el-button type="primary" @click="saveForm('0')">发布</el-button>
    </el-row>
  </div>
</template>

<script>
let ac;
import {
  queryAllClassification,
  addDemandSquare,
  queryDemandSquare,
  updateDemandSquare,
} from "@/api/addedServices";
export default {
  data() {
    return {
      ruleForm: {
        settingId: "",
        description: "",
        note: "",
        address: "",
        fileList: [],
      },
      rules: {
        settingId: [{ required: true, message: "请选择选择分类" }],
        address: [{ required: true, message: "请输入所在位置" }],
      },
      radio: "",
      options: [],
      dialogImageUrl: "",
      dialogVisible: false,
      map: {}, //赋值地图
      local: {}, //搜索
    };
  },
  created() {
    const { squareId } = this.$route.query;
    this.queryAllClassification();
    if (squareId) {
      this.queryDemandSquare(squareId);
    }
  },
  mounted() {
    this.createdMap();
  },
  beforeDestroy() {
    ac.removeEventListener("onConfirm", this.setValue);
  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    /**@method 创建地图 */
    createdMap() {
      let navigationControl = new BMap.NavigationControl({
        // 靠左上角位置
        anchor: BMAP_ANCHOR_TOP_LEFT,
        // LARGE类型
        type: BMAP_NAVIGATION_CONTROL_LARGE,
        // 启用显示定位
        enableGeolocation: true,
      });
      this.map = new BMap.Map("baidumap");
      this.map.centerAndZoom("北京", 12);
      this.map.addControl(navigationControl);

      ac = new BMap.Autocomplete({
        //建立一个自动完成的对象
        input: "suggestId",
        location: this.map,
      });
      ac.addEventListener("onConfirm", this.setValue);
    },
    setValue(e) {
      const {
        item: { value },
      } = e;
      this.ruleForm.address = `${value.city}${value.district}${value.business}`;
    },
    handProgress(event, file, fileList) {
      this.$message({
        message: "正在上传",
      });
    },
    handleSuccess(response, file, fileList) {
      this.$message.closeAll();
      this.$message({
        message: "上传成功",
        type: "success",
      });
      this.ruleForm.fileList = fileList;
    },
    myFun() {
      let pp = this.local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
      this.map.centerAndZoom(pp, 18);
      this.map.addOverlay(new BMap.Marker(pp)); //添加标注
      this.ruleForm.gps = JSON.stringify(pp);
    },
    theLocation(val) {
      this.map.clearOverlays(); //清除地图上所有覆盖物

      this.local = new BMap.LocalSearch(this.map, {
        //智能搜索
        onSearchComplete: this.myFun,
      });
      this.local.search(val);
    },
    /**@method 获取编辑数据 */
    async queryDemandSquare(squareId) {
      const result = await queryDemandSquare({ squareId });
      const {
        settingId,
        description,
        images,
        note,
        address,
        createdUserId,
        companyId,
      } = result.data;
      const imgs = JSON.parse(images);
      this.ruleForm = {
        settingId,
        description,
        fileList: imgs.map((item) => ({
          url: item,
          response: {
            data: item,
          },
        })),
        note,
        address,
        createdUserId,
        companyId,
      };
    },
    /**@method  获取分类*/
    async queryAllClassification() {
      try {
        const result = await queryAllClassification({ dataType: 1 });
        this.options = result?.data;
      } catch (error) {
        console.log(error);
      }
    },
    /**@method 发布 */
    saveForm(val) {
      /*  */
      const { squareId } = this.$route.query;
      let data = {
        ...this.ruleForm,
        source: "web",
        isDraft: val == "0" ? false : true,
        status: 0,
        images: this.ruleForm.fileList.map((item) =>
          item.response.data.indexOf("https") >= 0
            ? item.response.data
            : `https://edgar-wsl.oss-cn-beijing.aliyuncs.com/${item.response.data}`
        ),
      };
      if (!this.radio) {
        this.$message({
          showClose: true,
          message: "请勾选用户协议",
          type: "warning",
        });
        return;
      }
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          if (squareId) {
            //保存编辑
            await updateDemandSquare(
              { ...data, squareId },
              { showLoading: true }
            );
          } else {
            //添加请求
            await addDemandSquare(data, { showLoading: true });
          }

          this.$router.push({ path: "/myNeeds" });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
